import * as Icons from "lucide-react";
import React from "react";

/**
 * Render a lucide icon by string name. Falls back to MapPin if not found.
 */
export default function Icon({ name, className = "h-5 w-5", color, ...rest }) {
  const Cmp = Icons[name] || Icons.MapPin;
  return <Cmp className={className} style={color ? { color } : undefined} {...rest} />;
}
